import { render, staticRenderFns } from "./AdvisorsHeader.vue?vue&type=template&id=6bd5c85c&scoped=true&"
import script from "./AdvisorsHeader.vue?vue&type=script&lang=js&"
export * from "./AdvisorsHeader.vue?vue&type=script&lang=js&"
import style0 from "./AdvisorsHeader.vue?vue&type=style&index=0&id=6bd5c85c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd5c85c",
  null
  
)

export default component.exports